var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLiArrow = function SvgLiArrow(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 8 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.03941C0 9.82988 1.16227 10.5262 2.58699 9.57126L6.9174 6.7065C8.36087 5.77148 8.36087 4.21973 6.9174 3.28471L2.58699 0.419951C1.16227 -0.515073 0 0.161328 0 1.9518V8.03941Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLiArrow);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgOCAxMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMCA4LjAzOTQxQzAgOS44Mjk4OCAxLjE2MjI3IDEwLjUyNjIgMi41ODY5OSA5LjU3MTI2TDYuOTE3NCA2LjcwNjVDOC4zNjA4NyA1Ljc3MTQ4IDguMzYwODcgNC4yMTk3MyA2LjkxNzQgMy4yODQ3MUwyLjU4Njk5IDAuNDE5OTUxQzEuMTYyMjcgLTAuNTE1MDczIDAgMC4xNjEzMjggMCAxLjk1MThWOC4wMzk0MVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjwvc3ZnPg==";